import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { NavLink } from "react-router-dom";

const PriceList = ({ priceList, handleDelete, handleCheck, isChecked }) => {
  const date = priceList ? moment(priceList.date_created).utc().format("L") : "";
  return (
    <tr className={isChecked && "table-selected"}>
      <td style={{ width: "15%" }}>{date}</td>
      <td>{priceList ? priceList.description : ""}</td>
      <td>{priceList ? priceList.vendor_name : ""}</td>
      <td style={{ width: "15%" }}>
        <span className="d-flex justify-content-center">
          <NavLink className="ml-05 btn-sm btn-primary" to={`/price_lists/${priceList.id}`}>
            <i className="fa fa-eye"></i>
          </NavLink>
          <span className="ml-05 btn btn-sm btn-danger mr-0" onClick={handleDelete}>
            <i className="fa fa-trash"></i>
          </span>
        </span>
      </td>
      <td style={{ width: "15%" }} onClick={handleCheck}>
        <input className="form-check m-auto" type="checkbox" checked={isChecked} />
      </td>
    </tr>
  );
};

const PriceListsList = ({ priceLists, handleDelete, handleCheck, checkedLists }) => {
  const lastLists = priceLists.filter((list) => moment().isoWeek() === moment(list.date_created).isoWeek());
  const allLists = priceLists.filter((list) => moment().isoWeek() !== moment(list.date_created).isoWeek());
  return (
    <tbody>
      {lastLists.length > 0 && (
        <tr>
          <td className="grey pl-4" colspan="5">
            THIS WEEK PRICE LISTS
          </td>
        </tr>
      )}
      {lastLists.map((priceList) => {
        return (
          <PriceList
            priceList={priceList}
            key={priceList.id}
            isChecked={checkedLists.includes(priceList.id)}
            handleDelete={() => handleDelete(priceList.id)}
            handleCheck={() => handleCheck(priceList.id)}
          />
        );
      })}
      {allLists.length > 0 && (
        <tr>
          <td className="grey pl-4" colspan="5">
            ALL PRICE LISTS
          </td>
        </tr>
      )}
      {allLists.map((priceList) => {
        return (
          <PriceList
            priceList={priceList}
            key={priceList.id}
            isChecked={checkedLists.includes(priceList.id)}
            handleDelete={() => handleDelete(priceList.id)}
            handleCheck={() => handleCheck(priceList.id)}
          />
        );
      })}
    </tbody>
  );
};

PriceListsList.propTypes = {
  priceLists: PropTypes.array.isRequired,
  handleDelete: PropTypes.func,
};

export default PriceListsList;
